import { useEffect, useSyncExternalStore } from 'react';
import {
  getBillingSnapshot,
  refreshBillingState,
  subscribeBillingState,
  type PlatformBillingState,
} from '../services/platformBillingStore';

/** Intervalo de revalidação: rápido o bastante para desbloquear logo após o pagamento. */
const POLL_MS = 60_000;

/**
 * Estado da régua de inadimplência da plataforma. Compartilhado entre o banner
 * do layout, a tela de bloqueio e o interceptor de 402.
 *
 * @param options.poll revalida periodicamente — use só onde o estado precisa
 *                     mudar sem recarregar a página (layout principal).
 */
export function usePlatformBilling(options: { poll?: boolean } = {}): PlatformBillingState {
  const state = useSyncExternalStore(subscribeBillingState, getBillingSnapshot);

  useEffect(() => {
    if (!state.loaded) void refreshBillingState();
  }, [state.loaded]);

  useEffect(() => {
    if (!options.poll) return;
    const timer = setInterval(() => void refreshBillingState(), POLL_MS);
    return () => clearInterval(timer);
  }, [options.poll]);

  return state;
}

export default usePlatformBilling;
